export default "__VITE_ASSET__d6bTFRw5__"